"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const roomCreateStore_1 = require("@/room/room_create/roomCreateStore");
const react_hook_form_1 = require("react-hook-form");
const react_i18next_1 = require("react-i18next");
const components_1 = require("@/common/components");
const material_ui_confirm_1 = require("material-ui-confirm");
const Button_1 = __importDefault(require("@mui/material/Button"));
const styled_1 = __importDefault(require("@emotion/styled"));
const _1 = require(".");
function default_1() {
    var _a;
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const deliveryType = (0, react_redux_1.useSelector)((state) => state.deliveryType);
    const isFixed = deliveryType === '1';
    const isConditional = deliveryType === '4';
    const isDifferential = deliveryType === '3';
    const isCustom = deliveryType === '6';
    const { control, formState: { errors }, resetField, } = (0, react_hook_form_1.useForm)({ mode: 'onChange' });
    const isFeeFree = (0, react_redux_1.useSelector)((state) => state.roomData.fee_free);
    const defaultAdditionalPrice = ((_a = (0, react_redux_1.useSelector)((state) => state.additionalDeliveries[0])) === null || _a === void 0 ? void 0 : _a.origin_price) || '';
    const dispatch = (0, react_redux_1.useDispatch)();
    const onAdditionalPriceBlur = (additionalPriceInput) => {
        dispatch((0, roomCreateStore_1.modifyAdditional)({ origin_price: additionalPriceInput }));
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    const roomStatusCd = (0, react_redux_1.useSelector)((state) => state.roomData.room_status_cd);
    const isTemp = Boolean(roomStatusCd == 'ROOM_STATUS_00');
    const isEdit = (0, react_redux_1.useSelector)((state) => state.isEdit);
    const isCloneRoom = (0, react_redux_1.useSelector)((state) => Boolean(state.roomData.original_room));
    const isCustomDelivery = (0, react_redux_1.useSelector)((state) => state.isCustomDelivery);
    const isCustomOnly = isEdit && isCustomDelivery;
    const isNormalOnly = isEdit && !isCustomDelivery;
    const isCreateNewRoom = !isEdit && !isTemp && !isCloneRoom;
    const needDeliveryChangeWarning = (0, react_redux_1.useSelector)((state) => state.needDeliveryChangeWarning);
    const confirmIrreversibleDeliveryChange = () => {
        confirm({
            description: ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [t('폼 생성 후 수정 불가'), (0, jsx_runtime_1.jsx)("br", {}), t('[구매자 맞춤배송]은 폼 생성시에만'), (0, jsx_runtime_1.jsx)("br", {}), t('선택할 수 있어요~')] })),
            cancellationButtonProps: { style: { display: 'none' } },
        });
    };
    (0, react_1.useEffect)(() => {
        if (needDeliveryChangeWarning && isCreateNewRoom && !isCustom) {
            dispatch((0, roomCreateStore_1.setNeedDeliveryChangeWarning)());
            confirmIrreversibleDeliveryChange();
        }
    }, [isCustom]);
    const defaultCustomArr = (0, react_redux_1.useSelector)((state) => state.customDeliveries);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(DeliveryFeeSelectInputDiv, { children: [(0, jsx_runtime_1.jsxs)(components_1.NativeSelect, Object.assign({ onChange: e => dispatch((0, roomCreateStore_1.setDeliveryType)(e.target.value)), defaultValue: deliveryType }, { children: [(0, jsx_runtime_1.jsx)("option", Object.assign({ value: "2", disabled: isCustomOnly }, { children: t('무료배송') })), (0, jsx_runtime_1.jsx)("option", Object.assign({ value: "1", disabled: isCustomOnly }, { children: t('고정배송') })), (0, jsx_runtime_1.jsx)("option", Object.assign({ value: "4", disabled: isCustomOnly }, { children: t('조건부 무료배송') })), (0, jsx_runtime_1.jsx)("option", Object.assign({ value: "3", disabled: isCustomOnly }, { children: t('구매 개수 별 차등 배송') })), (0, jsx_runtime_1.jsx)("option", Object.assign({ value: "6", disabled: isNormalOnly }, { children: t('구매자 맞춤 배송') }))] }), `${deliveryType}_deliveryType`), isFixed && ((0, jsx_runtime_1.jsx)(_1.DeliveryFeeInputFixed, { control: control, isFeeFree: isFeeFree, errors: errors })), isConditional && ((0, jsx_runtime_1.jsx)(_1.DeliveryFeeInputConditional, { control: control, isFeeFree: isFeeFree, errors: errors })), isDifferential && ((0, jsx_runtime_1.jsx)(_1.DeliveryFeeInputDifferential, { control: control, isFeeFree: isFeeFree, errors: errors, resetField: resetField })), isCustom && ((0, jsx_runtime_1.jsx)(_1.DeliveryFeeInputCustom, { control: control, isFeeFree: isFeeFree, errors: errors, resetField: resetField })), !isCustom && ((0, jsx_runtime_1.jsxs)("div", Object.assign({ className: "delivery_fee_title_input" }, { children: [(0, jsx_runtime_1.jsx)("span", Object.assign({ className: "delivery_fee_title body2 gray-40" }, { children: t('제주/도서산간 추가') })), (0, jsx_runtime_1.jsx)(components_1.PriceCalculator, { name: "additional_price", control: control, defaultValue: defaultAdditionalPrice, onBlurFunc: onAdditionalPriceBlur, isFeeFree: isFeeFree, isDelivery: true })] })))] }), isCustom && defaultCustomArr.length < 5 && ((0, jsx_runtime_1.jsx)(Button_1.default, Object.assign({ sx: {
                    alignSelf: 'flex-end',
                    height: '32px',
                    p: '0 12px',
                    borderRadius: '6px',
                    border: '1px solid var(--gray-80)',
                    mt: '10px',
                    bgcolor: 'var(--white) !important',
                    color: 'var(--gray-80)',
                }, onClick: () => dispatch((0, roomCreateStore_1.addCustom)()) }, { children: (0, jsx_runtime_1.jsxs)("span", Object.assign({ className: "subtitle4" }, { children: ["+ ", t('배송방법 추가')] })) })))] }));
}
exports.default = default_1;
const DeliveryFeeSelectInputDiv = styled_1.default.div `
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  padding: 14px;
  border: 1px solid var(--gray-5);
  border-radius: 12px;
  box-shadow: 0px 2px 4px 0px var(--gray-5);
  .MuiInput-root {
    height: 48px;
    padding: 0 14px;
    border: 1px solid var(--gray-10);
    border-radius: 8px;
    font-size: 15px;
    color: var(--gray-80);
    .MuiNativeSelect-select {
      height: 100%;
      padding: 0;
    }
    .MuiNativeSelect-icon {
      right: 14px;
      width: 20px;
      height: 20px;
    }
  }
  .delivery_fee_title_input {
    display: grid;
    grid-template-columns: 0.5fr 0.5fr;
    gap: 4px 8px;
    .delivery_fee_title {
      display: flex;
      align-items: center;
      min-height: 40px;
      padding: 7px 13px;
      border: 1px solid var(--gray-10);
      border-radius: 8px;
      background-color: var(--surface-bg);
    }
  }
`;
